const styleOptions = {
    type: 'style',
    title: 'phong cách',
    options: [
        'colosseum',
        'kashmir',
        'weimar',
        'hamilton',
        'melissani',
        'moraine',
    ],
};

const sexOptions = {
    type: 'sex',
    title: 'giới tính',
    options: ['nam', 'nữ'],
};

const priceOptions = {
    type: 'price',
    title: 'sắp xếp theo',
    options: ['mặc định', 'giá tăng dần', 'giá giảm dần'],
};

export { styleOptions, sexOptions, priceOptions };
